<template>
    <b-table v-if="users !== null" :data="users">
        <template slot-scope="props">
            <b-table-column label="Controls">

            </b-table-column>
            <b-table-column label="Name">
                {{ props.row.first_name }} {{ props.row.last_name }}
            </b-table-column>
            <b-table-column label="Email">
                {{ props.row.email }}
            </b-table-column>
            <b-table-column label="Is Admin">
                <i class="fa fa-check" v-if="props.row.is_admin"></i>
                <i class="fa fa-times" v-else></i>
            </b-table-column>
        </template>
    </b-table>
    <loader v-else></loader>
</template>

<script>
import Loader from '../Loader';
import BTable from 'buefy/src/components/table/Table';
import BTableColumn from 'buefy/src/components/table/TableColumn';

export default {
  components: {
    BTableColumn,
    BTable,
    Loader,
  },
  name: 'admin-users',

  created() {
    this.$store.dispatch('adminUser/load');
  },

  computed: {
    users() {
      return this.$store.state.adminUser.users;
    },

    loading() {
      return this.$store.state.adminUser.loading;
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminUsers.vue